import { z } from "zod";

import { stringBoolSchema } from "./string-utils";

const sentryEnabledEnvSchema = z.object({
  VITE_SENTRY_ENABLED: z.literal("true"),
  VITE_SENTRY_DSN: z.string(),
  VITE_SENTRY_TRACES_SAMPLE_RATE: z.coerce.number().min(0).max(1),
  VITE_SENTRY_SEND_DEFAULT_PII: z.coerce.boolean(),
});

const sentryDisabledEnvSchema = z.object({
  VITE_SENTRY_ENABLED: z.literal("false"),
});

export const sentryEnvSchema = z.discriminatedUnion("VITE_SENTRY_ENABLED", [
  sentryEnabledEnvSchema,
  sentryDisabledEnvSchema,
]);

export const featureFlagEnvSchema = z.object({
  VITE_ENABLE_NEW_SECTION_MANAGEMENT: stringBoolSchema,
  VITE_ENABLE_SITE_DEFAULT_PROGRAM: stringBoolSchema,
});

export const envSchema = z
  .object({
    VITE_KILI_BASE_URL: z.string(),
    VITE_GOOGLE_MAPS_API_KEY: z.string(),
    VITE_MIXPANEL_TOKEN: z.string().nullish(),
    VITE_ZENDESK_CONTACT_URL: z.string(),
  })
  .merge(featureFlagEnvSchema)
  // We cant merge a discriminated union, we're intersecting with .and instead
  .and(sentryEnvSchema);

export type Env = z.infer<typeof envSchema>;
